import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheck, FaGlobe } from "react-icons/fa";

import CustomNavbar from "../components/CustomNavbar";
import Footer from "../components/Footer";
import { industries } from "../data/industries";
import { services } from "../data/services";

function Industries() {
  return (
    <>
      <CustomNavbar />

      <style>{`
        .idp {
          --peach-deep: #ff6b35;
          --peach: #ff9066;
          --peach-soft: #f3c09f;
          --peach-tint: #ffe9e0;
          --peach-ink: #c2410c;
        }

        /* --- Hero --- */
        .idp-hero {
          position: relative; overflow: hidden;
          padding: clamp(52px, 7vw, 88px) 0;
          background:
            radial-gradient(42rem 24rem at 86% 6%, rgba(255,107,53,.30), transparent 62%),
            linear-gradient(135deg, #ff9066 0%, #f3c09f 48%, #fff8f5 100%);
          color: #0f172a;
        }
        .idp-hero__blob {
          position: absolute; border-radius: 50%; pointer-events: none;
          filter: blur(80px); opacity: .5;
          width: 24rem; height: 24rem; bottom: -9rem; left: -8rem;
          background: radial-gradient(circle, #fff3ec, transparent 70%);
        }
        .idp-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: #ffffffdd; color: var(--peach-ink);
          padding: 9px 22px; border-radius: 999px;
          font-weight: 700; font-size: .78rem; letter-spacing: .1em;
          box-shadow: 0 8px 20px rgba(194,65,12,.16);
        }
        .idp-hero__title {
          margin-top: 22px; font-weight: 800; letter-spacing: -.02em;
          font-size: clamp(1.9rem, 4.6vw, 3.1rem); line-height: 1.14;
        }
        .idp-hero__title em {
          font-style: normal;
          background: linear-gradient(96deg, #c2410c, #ff6b35 60%, #b91c1c);
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .idp-hero__lead {
          margin-top: 18px; color: #4a3a33;
          font-size: clamp(1rem, 1.7vw, 1.08rem); line-height: 1.85; max-width: 560px;
        }
        .idp-btn {
          display: inline-flex; align-items: center; gap: 10px;
          text-decoration: none; font-weight: 700;
          padding: 13px 26px; border-radius: 14px;
          transition: transform .22s ease, box-shadow .22s ease, background .22s ease;
        }
        .idp-btn--solid {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          color: #0f172a; box-shadow: 0 12px 28px rgba(255,107,53,.4);
        }
        .idp-btn--solid:hover, .idp-btn--solid:focus-visible {
          color: #fff; transform: translateY(-3px);
          box-shadow: 0 18px 38px rgba(255,107,53,.55);
        }
        .idp-btn--ghost {
          background: rgba(255,255,255,.72); color: #0f172a;
          border: 1.5px solid rgba(15,23,42,.16);
        }
        .idp-btn--ghost:hover, .idp-btn--ghost:focus-visible {
          background: #fff; color: #0f172a; transform: translateY(-3px);
        }
        .idp-btn svg { transition: transform .22s ease; }
        .idp-btn:hover svg { transform: translateX(4px); }

        .idp-panel {
          position: relative; overflow: hidden;
          background: #fff; border-radius: 24px;
          padding: clamp(26px, 3.4vw, 38px);
          box-shadow: 0 26px 55px rgba(194,65,12,.22);
          border: 1px solid #ffe3d6;
        }
        .idp-panel__globe {
          width: 62px; height: 62px; border-radius: 18px; margin-bottom: 18px;
          display: grid; place-items: center;
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          color: #fff;
        }
        .idp-panel__h { font-weight: 800; color: #0f172a; font-size: 1.3rem; margin-bottom: 18px; }
        .idp-panel__row {
          display: flex; align-items: flex-start; gap: 11px;
          color: #334155; font-size: .95rem; margin-bottom: 12px;
        }
        .idp-tick {
          flex-shrink: 0; margin-top: 2px;
          width: 21px; height: 21px; border-radius: 50%;
          display: grid; place-items: center; font-size: .58rem; color: #fff;
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
        }
        .idp-panel__note {
          margin: 18px 0 0; padding-top: 16px; border-top: 1px solid #f1e4dc;
          color: #64748b; font-size: .9rem; line-height: 1.8;
        }

        /* --- Sector grid --- */
        .idp-grid {
          padding: clamp(56px, 7vw, 92px) 0;
          scroll-margin-top: 80px;
          background: linear-gradient(180deg, #fff8f5 0%, #ffffff 62%, #ffffff 100%);
        }
        .idp-h2 {
          margin-top: 20px; color: #0f172a; font-weight: 800;
          font-size: clamp(1.7rem, 3.6vw, 2.7rem);
          line-height: 1.16; letter-spacing: -.02em;
        }
        .idp-lead {
          max-width: 740px; margin: 14px auto 0;
          color: #64748b; line-height: 1.85; font-size: clamp(.96rem, 1.6vw, 1.05rem);
        }

        /* Peach flood on hover, echoing the home Industries section */
        .idp-card {
          position: relative; overflow: hidden;
          display: flex; flex-direction: column; height: 100%;
          padding: 28px 24px; border-radius: 20px;
          background: #fff; border: 1px solid #f0e4dd;
          box-shadow: 0 6px 22px rgba(194,65,12,.07);
          text-decoration: none;
          transition: transform .28s ease, box-shadow .28s ease;
        }
        .idp-card::before {
          content: ""; position: absolute; top: -46px; right: -46px;
          width: 108px; height: 108px; border-radius: 50%;
          background: linear-gradient(135deg, var(--peach), var(--peach-soft));
          opacity: .16;
          transition: transform .5s cubic-bezier(.22,1,.36,1), opacity .34s ease;
        }
        .idp-card > * { position: relative; z-index: 1; }
        .idp-card:focus-visible { outline: 3px solid var(--peach-deep); outline-offset: 3px; }
        .idp-card__icon {
          width: 58px; height: 58px; border-radius: 16px; margin-bottom: 18px;
          display: grid; place-items: center;
          background: var(--peach-tint); color: var(--peach-deep);
          transition: background .3s ease, color .3s ease, transform .3s ease;
        }
        .idp-card__title {
          color: #0f172a; font-weight: 700; font-size: 1.14rem;
          margin-bottom: 10px; transition: color .3s ease;
        }
        .idp-card__text {
          color: #64748b; font-size: .93rem; line-height: 1.75;
          margin-bottom: 16px; transition: color .3s ease;
        }
        .idp-card__chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 18px; }
        .idp-card__chip {
          display: inline-flex; align-items: center; gap: 6px;
          background: var(--peach-tint); color: var(--peach-ink);
          border-radius: 999px; padding: 4px 11px; font-size: .72rem; font-weight: 600;
          transition: background .3s ease, color .3s ease;
        }
        .idp-card__chip svg { font-size: .55rem; flex-shrink: 0; }
        .idp-card__more {
          margin-top: auto; display: inline-flex; align-items: center; gap: 8px;
          color: var(--peach-ink); font-weight: 700; font-size: .9rem;
          transition: color .3s ease;
        }
        .idp-card__more svg { transition: transform .28s ease; }

        /* A mouse hovers; a finger can't. On touch, lib/touchMotion.js adds
           .is-live as the card scrolls through the middle of the screen. */
        .idp-card:hover,
        .idp-card.is-live {
          transform: translateY(-7px);
          box-shadow: 0 24px 48px rgba(194,65,12,.24);
        }
        .idp-card:hover::before,
        .idp-card.is-live::before { transform: scale(11); opacity: 1; }
        /* Navy on peach is 8:1; white would be 2.8:1 */
        .idp-card:hover .idp-card__title,
        .idp-card:hover .idp-card__text,
        .idp-card:hover .idp-card__more,
        .idp-card.is-live .idp-card__title,
        .idp-card.is-live .idp-card__text,
        .idp-card.is-live .idp-card__more { color: #0f172a; }
        .idp-card:hover .idp-card__icon,
        .idp-card.is-live .idp-card__icon {
          background: #fff; color: var(--peach-deep); transform: scale(1.06);
        }
        /* Chips would vanish against the flood without their own swap */
        .idp-card:hover .idp-card__chip,
        .idp-card.is-live .idp-card__chip {
          background: rgba(255,255,255,.62); color: #0f172a;
        }
        .idp-card:hover .idp-card__more svg,
        .idp-card.is-live .idp-card__more svg { transform: translateX(5px); }

        /* --- Capability band --- */
        /* Not a second CTA: the footer already carries one on every page. */
        .idp-band {
          position: relative; overflow: hidden;
          padding: clamp(56px, 7vw, 88px) 0 clamp(92px, 10vw, 132px);
          color: #fff;
          background:
            radial-gradient(40rem 22rem at 84% 10%, rgba(255,107,53,.28), transparent 62%),
            linear-gradient(140deg, #131f36 0%, #0f172a 50%, #0b1120 100%);
        }
        .idp-band__mesh {
          position: absolute; inset: 0; pointer-events: none;
          background-image:
            linear-gradient(rgba(255,144,102,.07) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,144,102,.07) 1px, transparent 1px);
          background-size: 66px 66px;
          mask-image: radial-gradient(72% 60% at 50% 45%, #000 20%, transparent 100%);
          -webkit-mask-image: radial-gradient(72% 60% at 50% 45%, #000 20%, transparent 100%);
        }
        .idp-band__title {
          font-weight: 800; letter-spacing: -.02em; color: #fff;
          font-size: clamp(1.7rem, 3.8vw, 2.7rem); line-height: 1.16;
        }
        .idp-band__title em {
          font-style: normal;
          background: linear-gradient(105deg, var(--peach-soft), var(--peach) 55%, var(--peach-deep));
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .idp-band__text {
          max-width: 700px; margin: 16px auto 0; color: #cbd5e1; line-height: 1.85;
        }
        .idp-caps { display: flex; flex-wrap: wrap; gap: 12px; justify-content: center; margin-top: 32px; }
        .idp-cap {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 12px 20px; border-radius: 999px; text-decoration: none;
          background: rgba(255,255,255,.05);
          border: 1px solid rgba(255,144,102,.28);
          color: #e2e8f0; font-weight: 600; font-size: .92rem;
          transition: background .24s ease, color .24s ease,
                      border-color .24s ease, transform .24s ease;
        }
        .idp-cap svg { color: var(--peach); transition: color .24s ease; }
        .idp-cap:hover, .idp-cap:focus-visible {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          border-color: transparent; color: #0f172a; transform: translateY(-3px);
        }
        .idp-cap:hover svg { color: #fff; }

        @media (max-width: 575.98px) { .idp-btn { width: 100%; justify-content: center; } }
        @media (prefers-reduced-motion: reduce) {
          .idp-card, .idp-card::before, .idp-card__icon,
          .idp-btn, .idp-cap { transition: none; }
          .idp-card:hover, .idp-btn:hover, .idp-cap:hover { transform: none; }
          .idp-card:hover::before { transform: scale(11); }
        }
      `}</style>

      <div className="idp">
        {/* Hero */}
        <section className="idp-hero">
          <span className="idp-hero__blob" />
          <Container style={{ position: "relative", zIndex: 1 }}>
            <Row className="align-items-center g-5">
              <Col lg={6} data-aos="fade-right">
                <span className="idp-badge">
                  <FaGlobe />
                  INDUSTRIES WE SERVE
                </span>

                {/* theme.css hides <br> in section headings below 576px —
                    the explicit space stops the halves concatenating. */}
                <h1 className="idp-hero__title">
                  Industry Expertise
                  <br />{" "}
                  <em>Across Multiple Sectors</em>
                </h1>

                <p className="idp-hero__lead">
                  Combining industry knowledge, technology expertise, and
                  delivery excellence to help organizations achieve
                  transformation and growth.
                </p>

                {/* Both buttons were inert before — no link, no handler */}
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <a href="#sectors" className="idp-btn idp-btn--solid">
                    Explore Industries
                    <FaArrowRight />
                  </a>
                  <Link to="/contact" className="idp-btn idp-btn--ghost">
                    Discuss Your Sector
                  </Link>
                </div>
              </Col>

              <Col lg={6} data-aos="fade-left">
                <div className="idp-panel">
                  <span className="idp-panel__globe">
                    <FaGlobe size={28} />
                  </span>

                  <h2 className="idp-panel__h">Multi-Industry Expertise</h2>

                  {industries.map(({ slug, title }) => (
                    <div className="idp-panel__row" key={slug}>
                      <span className="idp-tick">
                        <FaCheck />
                      </span>
                      {title}
                    </div>
                  ))}

                  <p className="idp-panel__note">
                    Delivering tailored technology, transformation, and
                    consulting solutions across diverse sectors.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Sectors */}
        <section className="idp-grid" id="sectors">
          <Container>
            <div className="text-center mb-5" data-aos="fade-up">
              <span className="idp-badge">SECTORS WE SUPPORT</span>
              <h2 className="idp-h2">Industries We Serve</h2>
              <p className="idp-lead">
                Delivering tailored technology, transformation, and digital
                solutions that address industry-specific challenges.
              </p>
            </div>

            <Row className="g-4">
              {industries.map((industry, i) => {
                const { Icon } = industry;
                return (
                  <Col
                    xl={4}
                    md={6}
                    key={industry.slug}
                    data-aos="fade-up"
                    data-aos-delay={(i % 3) * 90}
                  >
                    <Link to={`/industries/${industry.slug}`} className="idp-card" data-live>
                      <span className="idp-card__icon">
                        <Icon size={26} />
                      </span>

                      <h3 className="idp-card__title">{industry.title}</h3>
                      <p className="idp-card__text">{industry.description}</p>

                      {/* Detail-page content the listing never surfaced */}
                      <span className="idp-card__chips">
                        {(industry.highlights || []).slice(0, 3).map((h) => (
                          <span className="idp-card__chip" key={h}>
                            <FaCheck />
                            {h}
                          </span>
                        ))}
                      </span>

                      <span className="idp-card__more">
                        Learn more <FaArrowRight />
                      </span>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          </Container>
        </section>

        {/* What we bring to each sector — cross-links to services */}
        <section className="idp-band">
          <span className="idp-band__mesh" />
          <Container className="text-center" style={{ position: "relative", zIndex: 1 }}>
            <h2 className="idp-band__title" data-aos="fade-up">
              What We Bring <em>To Every Sector</em>
            </h2>

            <p className="idp-band__text" data-aos="fade-up" data-aos-delay="80">
              The same delivery capability, shaped by the regulations,
              constraints, and customers of the industry it lands in.
            </p>

            <div className="idp-caps" data-aos="fade-up" data-aos-delay="150">
              {services.map(({ slug, title, Icon }) => (
                <Link to={`/services/${slug}`} className="idp-cap" key={slug}>
                  <Icon />
                  {title}
                </Link>
              ))}
            </div>
          </Container>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default Industries;
